import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import React from 'react';
import { renderProp } from '../utils/renderProp.js';
import { DropdownProvider } from './DropdownProvider.js';
import { useDropdown } from './useDropdown.js';

var Dropdown = function (_a) {
    var children = _a.children, _b = _a.contentRef, contentRef = _b === void 0 ? React.useRef(null) : _b, _c = _a.triggerRef, triggerRef = _c === void 0 ? React.useRef(null) : _c, props = __rest(_a, ["children", "contentRef", "triggerRef"]);
    var providerValue = useDropdown(__assign({ contentRef: contentRef, triggerRef: triggerRef }, props));
    return (jsx(DropdownProvider, __assign({ value: providerValue }, { children: renderProp({ prop: children, context: providerValue }) })));
};

export { Dropdown };
//# sourceMappingURL=Dropdown.js.map
